// Edition form for referee card

import * as Yup from 'yup';
import { userUpdate } from '../utils/firebase';
import Input from './Input';
import ContactsFields from './ContactsFields';
import CardEditTemplate from './CardEditTemplate';
import GuidedTour from './GuidedTour';
import { isMobilePhone, isEmail } from 'validator';
import { wrapProfileUpdate } from '../utils/misc';
import { useFirebase } from './FirebaseContextProvider';
import placeholderPerson from '../assets/images/placeholder-person.png';

const steps = [
  {
    target: '.referee-card-edit',
    title: 'Personal information',
    content: 'Fill in your personal information first to access the app',
  },
];

export default function RefereeCardEdit({ referee }) {
  const { user, userIsReferee } = useFirebase();
  const {
    id,
    name,
    phone,
    email,
    emailConsent,
    smsConsent,
  } = referee;

  const isOwnProfile = user?.id === id;

  const initialValues = {
    name: name || '',
    phone: phone || '',
    email: email || '',
    emailConsent: name ? emailConsent : true,
    smsConsent: name ? smsConsent : true,
  };

  const validationSchema = new Yup.ObjectSchema({
    name: Yup.string().max(100, 'Too long').required('Required'),
    phone: Yup.string()
      .required('Required')
      .test('is-valid-phone', 'Invalid', (value) =>
        value ? isMobilePhone(value, 'en-US', { strictMode: false }) : false,
      ),
    email: Yup.string()
      .test('is-valid-email', 'Invalid', (value) => isEmail(value))
      .required('Required'),
  });

  return (
    <GuidedTour steps={userIsReferee ? steps : []} tourKey='referee-card-edit-v1'>
      <CardEditTemplate
        className='referee-card-edit'
        showUploadWarning
        id={id}
        imgPath={referee.imgPath}
        imgThumbPath={referee.imgThumbPath}
        hasImage={!!referee.imgPath}
        placeholder={placeholderPerson}
        formConfig={{
          initialValues,
          validationSchema,
        }}
        update={wrapProfileUpdate(userUpdate, isOwnProfile)}
        requireImage
      >
        {(formik) => (
          <>
            <Input
              name='name'
              placeholder='Name'
              {...formik.getFieldProps('name')}
              error={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : null
              }
            />
            <ContactsFields
              formik={formik}
              emailDisabled
              consentDisabled={!isOwnProfile}
            />
          </>
        )}
      </CardEditTemplate>
    </GuidedTour>
  );
}
